import { Exclude, Type, TypeHelpOptions } from 'class-transformer';

export class DataListType {
  static classType<T>() {
    const result = (options: TypeHelpOptions) => {
      return (options.newObject as PaginationResult<T>).type;
    };

    return result;
  }
}

export class PaginationResult<T> {
  @Type(DataListType.classType<T>())
  dataList: Array<T>;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  totalPages: number;
  totalItems: number;

  @Exclude()
  type: any;

  constructor(type: any) {
    this.type = type;
  }
}
